module.exports = __webpack_public_path__ + "img/logo_prezydent.59ed8547.jpg";